var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { editorLocalization } from "survey-creator-core";
import { ReactElementFactory } from "survey-react-ui";
var PropertyGridPlaceholderComponent = /** @class */ (function (_super) {
    __extends(PropertyGridPlaceholderComponent, _super);
    function PropertyGridPlaceholderComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridPlaceholderComponent.prototype.render = function () {
        return (React.createElement("div", { className: "svc-property-grid-placeholder" },
            React.createElement("div", { className: "svc-property-grid-placeholder__header" },
                React.createElement("span", { className: "svc-property-grid-placeholder__title" }, editorLocalization.getString("ed.propertyGridPlaceholderTitle")),
                React.createElement("span", { className: "svc-property-grid-placeholder__description" }, editorLocalization.getString("ed.propertyGridPlaceholderDescription"))),
            React.createElement("div", { className: "svc-property-grid-placeholder__content" },
                React.createElement("div", { className: "svc-property-grid-placeholder__gap" }),
                React.createElement("div", { className: "svc-property-grid-placeholder__image" }))));
    };
    return PropertyGridPlaceholderComponent;
}(React.Component));
export { PropertyGridPlaceholderComponent };
ReactElementFactory.Instance.registerElement("svc-property-grid-placeholder", function (props) {
    return React.createElement(PropertyGridPlaceholderComponent, props);
});
